import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PathArrow } from 'iconoir-react';

export const TrackingSol = ({ tableMeta }) => {
    const navigate = useNavigate();

    return (
        <button
            className='p-1 cursor-pointer bg-colorprimary hover:bg-colorsecondary text-white rounded-md'
            onClick={() => navigate(`/Solicitud/tracking/${tableMeta.id}`)}
            title="Seguimiento de la solicitud"
            aria-label="Ver seguimiento de la solicitud"
        >
            <PathArrow />
        </button>
    );
};
